import RangeRepository from "@/repositories/vns/RangeRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'ranges',
    namespaced: true,
    state: {
        ...makeState(),
        results: []
    },
    getters: {
        ...makeGetters(),

        results (state) {
            return state.results
        },
    },
    mutations: {
        ...makeMutations(),

        setResults (state, array) {
            state.results = array
        },

    },
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await RangeRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await RangeRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
            })
            commit('setLoading', false)
        },
        async listVnsReports ({ commit, dispatch }, params) {
            commit('setLoading', true)
            await RangeRepository.listVnsReports(params).then(response => {
                commit('setResults', response.data.data)
            })
            commit('setLoading', false)
        }
    }
}
